// Lowercased Gregor keys (slug.Make lowercases them) — NOT the camelCase keys
// the LaunchDarkly SDK exposed. Keep them lowercased or evaluation breaks.
export const ENABLE_V2_FEED_PAGE_FLAG_KEY = 'enablev2feedpage'
export const ENABLE_EXPERT_DASH_FLAG_KEY = 'enable-expert-dash'
export const ENABLE_MEDNET_GPT_FLAG_KEY = 'enablemednetgpt'
export const QUESTION_SEARCH_ALGORITHM_FLAG_KEY = 'questionsearchalgorithm'
export const ENFORCE_ALGOLIA_QUESTION_SEARCH_IN_AUTO_COMPLETE_FLAG_KEY =
  'enforcealgoliaquestionsearchinautocomplete'
export const ENABLE_CLINICAL_TRIALS_SEARCH_FLAG_KEY =
  'enable-clinical-trials-search'
export const ENABLE_CME_COLLECTION_FLAG_KEY = 'enable-cme-collection'
export const SHOW_NEW_SEARCH_MODAL_FLAG_KEY = 'shownewsearchmodal'
